import { render, staticRenderFns } from "./ConfigSIC.vue?vue&type=template&id=dd1f65ea"
import script from "./ConfigSIC.vue?vue&type=script&lang=js"
export * from "./ConfigSIC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports